module.exports = __webpack_public_path__ + "img/differences.e2a24c63.jpg";